import { swissborg } from "./companies";
import { SponsorDescription } from "../../../model";

export const pekkoSponsors: SponsorDescription[] = [swissborg];
